import { TableRowProps } from '@material-ui/core';

import { ResourcePathArgs, useResourcePath } from '../../hooks/useResourcePath';
import { LinkableTableRow } from '../LinkableTableRow/LinkableTableRow';

export type ResourceTableRowMuiProps = TableRowProps & ResourcePathArgs;

export const ResourceTableRowMui = ({
  routeRef,
  name,
  children,
  params,
  transform,
  ...tableRowProps
}: ResourceTableRowMuiProps) => {
  const path = useResourcePath({
    routeRef,
    name,
    params,
    transform,
  });

  return (
    <LinkableTableRow {...tableRowProps} to={path || ''}>
      {children}
    </LinkableTableRow>
  );
};
